/**
 *
 * Asynchronously loads the component for TimeSlots
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TimeSlots = lazyLoad(
  () => import('./index'),
  module => module.TimeSlots,
);
